<div class="organization-configuration msi-padding-s">
  <section class="organization-configuration__section">
    <app-organization-settings />
  </section>
  <section class="organization-configuration__section organization-configuration__section--sharing">
    <app-data-sharing />
  </section>
</div>
